function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5 33C32.9558 33 39 26.9558 39 19.5C39 12.0442 32.9558 6 25.5 6C18.0442 6 12 12.0442 12 19.5C12 26.9558 18.0442 33 25.5 33Z",
  fill: "#4F9DDE"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.645 14.645L20.2914 14.2914L20.2914 14.2914L20.645 14.645ZM21.3521 14.645L20.9985 14.9985L20.9985 14.9985L21.3521 14.645ZM20.645 15.3521L20.9985 14.9985L20.9985 14.9985L20.645 15.3521ZM25.048 19.7551L25.4016 20.1087L25.7551 19.7551L25.4016 19.4016L25.048 19.7551ZM20.645 24.1581L20.9985 24.5117L20.9985 24.5117L20.645 24.1581ZM20.645 24.8652L20.2914 25.2188L20.2914 25.2188L20.645 24.8652ZM21.3521 24.8652L21.7056 25.2188L21.7056 25.2188L21.3521 24.8652ZM25.7551 20.4622L26.1087 20.1087L25.7551 19.7551L25.4016 20.1087L25.7551 20.4622ZM30.8652 24.8652L31.2188 25.2188L31.2188 25.2188L30.8652 24.8652ZM26.4622 19.7551L26.1087 19.4016L25.7551 19.7551L26.1087 20.1087L26.4622 19.7551ZM30.8652 15.3521L30.5117 14.9985L30.5117 14.9985L30.8652 15.3521ZM30.8652 14.645L31.2188 14.2914L31.2188 14.2914L30.8652 14.645ZM30.1581 14.645L30.5117 14.9985L30.5117 14.9985L30.1581 14.645ZM25.7551 19.048L25.4016 19.4016L25.7551 19.7551L26.1087 19.4016L25.7551 19.048ZM20.9985 14.9985L20.9985 14.9985L21.7056 14.2914C21.3151 13.9009 20.682 13.9009 20.2914 14.2914L20.9985 14.9985ZM20.9985 14.9985L20.9985 14.9985L20.2914 14.2914C19.9009 14.682 19.9009 15.3151 20.2914 15.7056L20.9985 14.9985ZM25.4016 19.4016L20.9985 14.9985L20.2914 15.7056L24.6944 20.1087L25.4016 19.4016ZM20.9985 24.5117L25.4016 20.1087L24.6944 19.4016L20.2914 23.8046L20.9985 24.5117ZM20.9985 24.5117V24.5117L20.2914 23.8046C19.9009 24.1951 19.9009 24.8283 20.2914 25.2188L20.9985 24.5117ZM20.9985 24.5117L20.9985 24.5117L20.2914 25.2188C20.682 25.6093 21.3151 25.6093 21.7056 25.2188L20.9985 24.5117ZM25.4016 20.1087L20.9985 24.5117L21.7056 25.2188L26.1087 20.8158L25.4016 20.1087ZM30.5117 24.5117L26.1087 20.1087L25.4016 20.8158L29.8046 25.2188L30.5117 24.5117ZM30.5117 24.5117L30.5117 24.5117L29.8046 25.2188C30.1951 25.6093 30.8283 25.6093 31.2188 25.2188L30.5117 24.5117ZM30.5117 24.5117V24.5117L31.2188 25.2188C31.6093 24.8283 31.6093 24.1951 31.2188 23.8046L30.5117 24.5117ZM26.1087 20.1087L30.5117 24.5117L31.2188 23.8046L26.8158 19.4016L26.1087 20.1087ZM30.5117 14.9985L26.1087 19.4016L26.8158 20.1087L31.2188 15.7056L30.5117 14.9985ZM30.5117 14.9985L30.5117 14.9985L31.2188 15.7056C31.6093 15.3151 31.6093 14.682 31.2188 14.2914L30.5117 14.9985ZM30.5117 14.9985L30.5117 14.9985L31.2188 14.2914C30.8283 13.9009 30.1951 13.9009 29.8046 14.2914L30.5117 14.9985ZM26.1087 19.4016L30.5117 14.9985L29.8046 14.2914L25.4016 18.6944L26.1087 19.4016ZM20.9985 14.9985L25.4016 19.4016L26.1087 18.6944L21.7056 14.2914L20.9985 14.9985Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 51,
  height: 51,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgCloseCircle = function SvgCloseCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeCircle.1f12d769.svg";
export { ForwardRef as ReactComponent };